/* eslint-disable react/prop-types */
import React from 'react';
import '../../../styles/components/KnowledgeCentre/KnowledgeCentre.scss';
import ShareIcon from '@mui/icons-material/Share';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import IconButton from '@mui/material/IconButton';
// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import useMoengage from '../../../hooks/useMoengage';
import {
  CONTENT_SECTIONS,
  VIEW_TYPES,
  ANALYTICS_EVENTS,
} from '../../../constants/MitraContentConstants';
import Play from '../../../assets/play.png';

export default function VideoView(props) {
  const {
    hideDescription = false,
    sliderImageClasses,
    video,
    handleClickOpen,
    handleClickLike,
    likedItems,
    getUpdatedSelectedLikeButton,
    handleClickShare,
    contentSection = CONTENT_SECTIONS.MITRA_SHOTS,
  } = props;
  const [, , triggerContentInteractedEvent] = useMoengage();

  const handleAnalyticsEvent = event => {
    triggerContentInteractedEvent(event, {
      content_url:video.url,
      container_position: video.containerPosition,
      section: contentSection,
    });
  };

  return (
    <div
      style={{
        marginTop: '50px',
      }}
    >
      <Card sx={{ maxWidth: '100%' }}>
        <div className="container1">
          <img
            className={sliderImageClasses}
            src={`https://img.youtube.com/vi/${
              video.videoUUID ? video.videoUUID : video.id
            }/hqdefault.jpg`}
            width="100%"
            height="181px"
            alt=""
          />
          <div className="mask flex-center">
            <img
              alt=""
              className="slider_play"
              src={Play}
              onClick={() => {
                handleClickOpen(video);
                handleAnalyticsEvent(ANALYTICS_EVENTS.VIDEO_PLAYED);
              }}
            />
          </div>
        </div>

        {!hideDescription && (
          <CardContent>
            <Typography
              style={{
                fontSize: '17px',
              }}
              gutterBottom
              variant="p"
              component="div"
            >
              {video.title}
            </Typography>
            <Typography
              style={{
                fontSize: '11px',
              }}
              variant="body2"
              color="text.secondary"
            >
              {video.description}
            </Typography>
          </CardContent>
        )}
        <CardActions
          style={{
            marginTop: '-10px',
            float: 'right',
          }}
        >
          <IconButton
            aria-label="like"
            style={{ color: likedItems.includes(video.id) ? 'orange' : 'black' }}
            onClick={() => {
              if (typeof handleClickLike === 'function') {
                handleClickLike(video);
              }
              handleAnalyticsEvent(ANALYTICS_EVENTS.VIDEO_LIKE_BUTTON_CLICK);
              getUpdatedSelectedLikeButton(video.id);
            }}
          >
            <ThumbUpIcon />
          </IconButton>

          <IconButton
            aria-label="share"
            style={{ color: 'black' }}
            color="primary"
            onClick={() => {
              handleAnalyticsEvent(ANALYTICS_EVENTS.VIDEO_SHARE_BUTTON_CLICK);
              handleClickShare(video, VIEW_TYPES.VIDEO);
            }}
          >
            <ShareIcon />
          </IconButton>
        </CardActions>
      </Card>
    </div>
  );
}
